import React from 'react';
import { Text } from '@moda/om';

import './FineJewelryReturnMessage.scss';

interface Props {
  className?: string;
}

export const FineJewelryReturnMessage: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <Text treatment="body2" color="ink">
        Reason you cannot self return{' '}
      </Text>
      <Text treatment="body2" color="cement">
        Please contact{' '}
        <a className="FineJewelryReturnMessage__link" href="mailto:care@modaoperandi.com">
          care@modaoperandi.com{' '}
        </a>
        or call at{' '}
        <a className="FineJewelryReturnMessage__link" href="tel:+18007079898">
          1-800-707-9898{' '}
        </a>
        to request a label if the fine jewelry item is eligible for a return. If approved, please
        return to the appropriate warehouse within the 14 day delivery window.
      </Text>
    </div>
  );
};
